const initialState = {
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js